import React from "react";

export default function EmployeeKPICards({ dataset }) {
  if (!dataset) {
    return (
      <p className="text-center text-gray-500">No KPI data available</p>
    );
  }

  const {
    labels = [],
    totalPaidHours = [],
    calculatedDailyHours = [],
    activeEmployeeCount = [],
  } = dataset;

  // ✅ Get yesterday's date (not today)
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
console.log(yesterday)

const formatDateresult = (dateStr) => {
  const d = new Date(dateStr);  
  const mm = String(d.getMonth() + 1).padStart(2, "0"); 
  const dd = String(d.getDate()).padStart(2, "0");      
  const yy = String(d.getFullYear()).slice(-2);         
  const day = d.toLocaleString("en-US", { weekday: "short" });

  return `${mm} ${dd} ${yy} ${day}`;
};
  const yesterdayLabel = formatDateresult(yesterday);
console.log(yesterdayLabel)
  // Find index of yesterday in labels
  const yesterdayIndex = labels.findIndex((label) => label === yesterdayLabel);

  const hasData = yesterdayIndex !== -1;

  const latestPaid = hasData ? totalPaidHours[yesterdayIndex] || 0 : 0;
  const latestDaily = hasData ? calculatedDailyHours[yesterdayIndex] || 0 : 0;
  const latestEmp = hasData ? activeEmployeeCount[yesterdayIndex] || 0 : 0;
console.log("data",latestPaid,latestDaily,latestEmp)
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
      {/* Total Paid Hours */}
      <div
        className={`bg-white rounded-2xl shadow p-6 text-center ${
          hasData ? "" : "opacity-50 blur-[1px]"
        }`}
      >
        <p className="text-gray-500 text-sm">Total Paid Hours</p>
        <p className="text-2xl font-bold text-[#9369A9]">
          {hasData ? `${latestPaid.toFixed(2)} hrs` : "No Data"}
        </p>
      </div>

      {/* Calculated Daily Hours */}
      <div
        className={`bg-white rounded-2xl shadow p-6 text-center ${
          hasData ? "" : "opacity-50 blur-[1px]"
        }`}
      >
        <p className="text-gray-500 text-sm">Calculated Daily Hours</p>
        <p className="text-2xl font-bold text-orange-500">
          {hasData ? `${latestDaily} hrs` : "No Data"}
        </p>
      </div>

      {/* Active Employee Count */}
      <div
        className={`bg-white rounded-2xl shadow p-6 text-center ${
          hasData ? "" : "opacity-50 blur-[1px]"
        }`}
      >
        <p className="text-gray-500 text-sm">Active Employee Count</p>
        <p className="text-2xl font-bold text-green-600">
          {hasData ? latestEmp : "No Data"}
        </p>
      </div>
    </div>
  );
}
